import Icon from '../components/Icon.vue'

Icon.register({"caret-down":{"width":1024,"height":1792,"paths":[{"d":"M1024 704q0 26-19 45l-448 448q-19 19-45 19t-45-19l-448-448q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/caret-down.js
// module id = 616
// module chunks = 1